const POSTGREST_MESSAGES: Record<string, string> = {
  "42501": "You don't have permission to do that.",
  "23505": "This already exists.",
  "23503": "This references something that doesn't exist.",
  "23502": "A required field is missing.",
  "22P02": "Invalid input format.",
  PGRST301: "Session expired. Please log in again.",
};

export function normalizeError(error: unknown): string {
  if (!error) return "Something went wrong.";

  // Supabase PostgrestError shape: { code, message, details, hint }
  if (typeof error === "object" && error !== null && "code" in error) {
    const pgError = error as { code: string; message?: string };
    const mapped = POSTGREST_MESSAGES[pgError.code];
    if (mapped) return mapped;
    if (pgError.message) return pgError.message;
  }

  // Standard Error
  if (error instanceof Error) {
    if (error.message === "Failed to fetch" || error.message === "Load failed") {
      return "Connection lost. Please check your internet.";
    }
    return error.message;
  }

  // String
  if (typeof error === "string") return error;

  return "Something went wrong.";
}
